import React, {useEffect, useState} from "react";
import {useDebounce} from "use-debounce";
import {Input, InputProps} from "antd";

export const DebounceInput = (
    props: {
        value: string | undefined,
        onChange: (value: string) => void,
        placeholder?: string,
        style?: React.CSSProperties,
        disabled?: boolean
    }
) => {
    const [text, setText] = useState(props.value)
    const [debouncedText] = useDebounce(text, 500);

    useEffect(() => {
        setText(props.value)
    }, [props.value]);

    useEffect(() => {
        if (text != props.value) {
            props.onChange(text ?? '')
        }
    }, [debouncedText]);

    return(
        <Input style={props.style}
               placeholder={props.placeholder}
               value={text}
               disabled={props.disabled}
               onChange={(e) => setText(e.target.value)}
        />
    )
}